import React, { useState } from 'react';
import Carouselteam from '../components/carouselteam';
import Bannercontact from '../components/bannercontact';
import Pricing from '../components/pricing';
import Testimony from '../components/carouseltestimony';
import Footer from '../components/footer';


export default () => {
  const [isKartonModalOpen, setIsKartonModalOpen] = useState(false);
  const [isGuvenlikModalOpen, setIsGuvenlikModalOpen] = useState(false);

  const openKartonModal = () => {
    setIsKartonModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeKartonModal = () => {
    setIsKartonModalOpen(false);
    document.body.style.overflow = 'unset';
  };

  const openGuvenlikModal = () => {
    setIsGuvenlikModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeGuvenlikModal = () => {
    setIsGuvenlikModalOpen(false);
    document.body.style.overflow = 'unset';
  };

  return (
  <div>
      <section className='jumbotron breadcumb h-vh' style={{backgroundImage: `url(${'./img/hero.png'})`}}>
        <div className='homebread'>
          <div className='container-fluid'>
            <div className='row m-10-hor'>
              <div className='col-md-8 mr-auto '>
                <div className='heading'>
                  HAN GRUP
                </div>
                <div className='content'>
                  "Hangrup, güvenlik sistemleri ve kutu ambalaj alanında yenilikçi çözümler sunan güvenilir
                   bir markadır. Hem güvenliği sağlayan teknolojileri hem de ürünlerinizi koruyan ambalajları
                    üstün kalite anlayışıyla üretir. Profesyonel yaklaşımıyla her ihtiyaca uygun, dayanıklı
                     ve etkili çözümler sunmayı hedefler."
                </div>
                <div className="btn" onClick={()=> window.open("/about", "_self")}>
                  <span className="shine"></span>
                  <span>Hakkımızda</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container-fluid black_more'>
        <div className='row m-10-hor'>
                 <div className='col-md-12'>
                    <div className='heading'>
                      “<b style={{ fontSize: '1.6em' }}>Hangrup</b>
                      <span style={{ fontSize: '0.9em' }}>, Güvenlik ve Ambalajda Kesintisiz Kalite.</span>”
                    </div>
                  </div>

        </div>
    </section>

    <section className='container-fluid p-0'>
        <div className='row' style={{ margin: 0, display: 'flex', flexWrap: 'wrap' }}>

          <div className="col-md-6 col-12 px-0 karton-resim">
            <img src="./img/kutu.jpg" className="imgslickz" alt="Karton Kutu Ambalaj" style={{ width: '100%', height: 'auto', display: 'block' }}/>
          </div>

          <div className="col-md-6 col-12 centered section-content karton-yazi">
            <div className="responsive-padding">
              <div className="heading home-heading-decorative">
                Karton Kutu Ambalaj
              </div>
              <p className="mt-3 responsive-text">
               Karton kutu ambalaj ürünlerimiz, dayanıklı yapısı ve yüksek kaliteli üretim standartlarıyla 
               farklı sektörlerin ihtiyaçlarına uygun çözümler sunar. Üretim sürecinde hem estetiği hem de 
               işlevselliği ön planda tutarak, ürünlerinizi güvenle taşıyıp koruyan ambalajlar sağlıyoruz. 
               Müşterilerimizin taleplerine özel ölçü ve tasarım seçenekleriyle en verimli
                ambalaj çözümlerini sunmayı hedefliyoruz.
              </p>
              <div className='btn' onClick={openKartonModal} style={{ cursor: 'pointer', marginTop: '15px' }}>
                <span className="shine"></span>
                <span>Detaylar</span>
              </div>
            </div>
          </div>

          {/* Mobilde resim önce, desktop'ta yazı önce */}
          <div className="col-md-6 col-12 px-0 guvenlik-resim">
            <img src="./img/guvenlik.png" className="imgslickz" alt="Güvenlik Sistemleri" style={{ width: '100%', height: 'auto', display: 'block' }}/>
          </div>

          <div className="col-md-6 col-12 centered section-content guvenlik-yazi">
            <div className="responsive-padding">
              <div className="heading home-heading-decorative">
                Güvenlik Sistemleri
              </div>
              <p className="mt-3 responsive-text">
                Güvenlik sistemleri alanında sunduğumuz çözümler, modern teknolojiyle donatılmış 
                yapıları sayesinde işletme ve yaşam alanlarınızı en üst düzeyde korumayı hedefler. 
                Profesyonel ekibimiz, ihtiyaca özel güvenlik kamera sistemleri, alarm çözümleri
                 ve kontrol altyapılarıyla güvenilir ve uzun ömürlü uygulamalar sunar. Müşteri 
                 odaklı yaklaşımımızla, her mekâna uygun güvenlik çözümlerini titizlikle tasarlayıp hayata geçiriyoruz.
              </p>
              <div className='btn' onClick={openGuvenlikModal} style={{ cursor: 'pointer', marginTop: '15px' }}>
                <span className="shine"></span>
                <span>Detaylar</span>
              </div>
            </div>
          </div>

        </div>
  </section>
    <Bannercontact/>
   
    <Testimony />
    <Footer />

    {/* Scrollbar Styles */}
    <style>
      {`
        .modal-content::-webkit-scrollbar {
          width: 10px;
        }
        .modal-content::-webkit-scrollbar-track {
          background: #2a2a2a;
          border-radius: 10px;
        }
        .modal-content::-webkit-scrollbar-thumb {
          background: #1a1a1a;
          border-radius: 10px;
          border: 2px solid #2a2a2a;
        }
        .modal-content::-webkit-scrollbar-thumb:hover {
          background: #0a0a0a;
        }
        .modal-content {
          scrollbar-width: thin;
          scrollbar-color: #1a1a1a #2a2a2a;
        }
        .responsive-padding {
          padding: 1.5rem;
        }
        @media (min-width: 768px) {
          .responsive-padding {
            padding: 3rem;
          }
        }
        .responsive-text {
          font-size: 14px;
          line-height: 1.6;
        }
        @media (min-width: 768px) {
          .responsive-text {
            font-size: inherit;
            line-height: inherit;
          }
        }
        .section-content {
          padding: 20px 15px;
        }
        @media (min-width: 768px) {
          .section-content {
            padding: 20px;
          }
        }
        /* Row flex container olmalı */
        .row {
          display: flex !important;
          flex-wrap: wrap !important;
        }
        /* Mobilde: HTML sırası zaten doğru - resim önce, yazı sonra */
        /* Desktop'ta: Güvenlik yazısı resmin üstünde olsun */
        @media (min-width: 768px) {
          .guvenlik-resim {
            order: 4 !important;
          }
          .guvenlik-yazi {
            order: 3 !important;
          }
        }
        .modal-content-responsive {
          padding: 25px 20px;
          margin: 10px;
        }
        @media (min-width: 768px) {
          .modal-content-responsive {
            padding: 50px;
            margin: 0;
          }
        }
        .modal-heading-responsive {
          font-size: 24px;
        }
        @media (min-width: 768px) {
          .modal-heading-responsive {
            font-size: 32px;
          }
        }
        .modal-text-responsive {
          font-size: 14px;
        }
        @media (min-width: 768px) {
          .modal-text-responsive {
            font-size: 16px;
          }
        }
        .modal-h3-responsive {
          font-size: 20px;
        }
        @media (min-width: 768px) {
          .modal-h3-responsive {
            font-size: 24px;
          }
        }
        .modal-slogan-responsive {
          font-size: 16px;
        }
        @media (min-width: 768px) {
          .modal-slogan-responsive {
            font-size: 18px;
          }
        }
        /* Köşe dekorasyonu - Tüm ekranlarda */
        .home-heading-decorative {
          position: relative;
          padding: 20px 25px;
        }
        .home-heading-decorative::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          height: 50px;
          border-top: 3px solid #d4af37;
          border-left: 3px solid #d4af37;
          opacity: 0.8;
        }
        .home-heading-decorative::after {
          content: '';
          position: absolute;
          bottom: 0;
          right: 0;
          width: 50px;
          height: 50px;
          border-bottom: 3px solid #d4af37;
          border-right: 3px solid #d4af37;
          opacity: 0.8;
        }
        @media (max-width: 768px) {
          .home-heading-decorative {
            padding: 15px 20px;
          }
          .home-heading-decorative::before {
            width: 40px;
            height: 40px;
            border-top: 3px solid #d4af37;
            border-left: 3px solid #d4af37;
          }
          .home-heading-decorative::after {
            width: 40px;
            height: 40px;
            border-bottom: 3px solid #d4af37;
            border-right: 3px solid #d4af37;
          }
        }
        @media (max-width: 480px) {
          .home-heading-decorative {
            padding: 12px 15px;
          }
          .home-heading-decorative::before {
            width: 30px;
            height: 30px;
            border-top: 2px solid #d4af37;
            border-left: 2px solid #d4af37;
          }
          .home-heading-decorative::after {
            width: 30px;
            height: 30px;
            border-bottom: 2px solid #d4af37;
            border-right: 2px solid #d4af37;
          }
        }
      `}
    </style>

    {/* Karton Kutu Ambalaj Modal */}
    {isKartonModalOpen && (
      <div 
        className="modal-overlay" 
        onClick={closeKartonModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
          }}
        >
          <div 
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#1a1a1a',
              borderRadius: '12px',
              maxWidth: '900px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative',
              padding: '50px',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}
          >
          <button
            onClick={closeKartonModal}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'transparent',
              border: 'none',
              fontSize: '32px',
              cursor: 'pointer',
              color: '#fff',
              fontWeight: '300',
              lineHeight: '1',
              padding: '0',
              width: '35px',
              height: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            ×
          </button>
          <div style={{ marginBottom: '20px' }}>
            <h2 className="modal-heading-responsive" style={{ 
              fontWeight: '700', 
              marginBottom: '15px',
              color: '#fff',
              letterSpacing: '0.5px'
            }}>
              Karton Kutu Ambalaj Çözümlerimiz – Hangrup
            </h2>
            <div style={{
              fontSize: '16px',
              color: '#d4af37',
              fontStyle: 'italic',
              marginBottom: '30px',
              fontWeight: '400',
              letterSpacing: '1px',
              borderLeft: '3px solid #d4af37',
              paddingLeft: '15px'
            }}
            className="modal-slogan-responsive">
              Yükünüz bizimle güvende
            </div>
            <div className="modal-text-responsive" style={{ 
              lineHeight: '1.9', 
              color: '#e0e0e0',
              textAlign: 'justify'
            }}>
              <p style={{ marginBottom: '20px', color: '#d0d0d0' }}>
                Hangrup olarak, farklı sektörlerin ihtiyaçlarına özel yüksek kaliteli karton kutu ve ambalaj çözümleri üretiyoruz. Gıda, e-ticaret, lojistik ve sanayi başta olmak üzere geniş bir kullanım alanına hitap eden ürünlerimiz; dayanıklılık, hijyen ve estetik kriterleri göz önünde bulundurularak üretilmektedir.
              </p>
              <p style={{ marginBottom: '20px', color: '#d0d0d0' }}>
                Modern üretim altyapımız, hızlı termin sürelerimiz ve müşteri odaklı yaklaşımımız ile işletmenizin ambalaj süreçlerini güvenle yönetiyoruz. İhtiyacınıza özel ölçü, baskı ve tasarım seçenekleriyle markanızın değerini en iyi şekilde yansıtan çözümler sunuyoruz.
              </p>
              <h3 className="modal-h3-responsive" style={{ 
                fontWeight: '600', 
                marginTop: '35px',
                marginBottom: '20px',
                color: '#fff',
                borderBottom: '2px solid #d4af37',
                paddingBottom: '10px'
              }}>
                Üretimini Yaptığımız Karton Kutu Çeşitleri
              </h3>
              <ul style={{ 
                marginBottom: '20px',
                paddingLeft: '25px',
                listStyleType: 'none',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '10px'
              }}>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Pizza Kutuları
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Pastane Kutuları
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Börek Kutuları
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Sanayi Kutuları
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> İçecek Kutuları
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> E-Ticaret Kutuları
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Kargo Kutuları
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Taşıma Kutuları
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Triplex Kutular
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Karton Levhalar
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Separatör (Bölücü) Ürünler
                </li>
              </ul>
              <h3 className="modal-h3-responsive" style={{ 
                fontWeight: '600', 
                marginTop: '35px',
                marginBottom: '20px',
                color: '#fff',
                borderBottom: '2px solid #d4af37',
                paddingBottom: '10px'
              }}>
                Neden Hangrup?
              </h3>
              <ul style={{ 
                marginBottom: '20px',
                paddingLeft: '0',
                listStyleType: 'none'
              }}>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Dayanıklı ve kaliteli ham madde kullanımı
                </li>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Hijyenik üretim standartları
                </li>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Özel ölçü ve baskı seçenekleri
                </li>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Hızlı üretim ve zamanında teslimat
                </li>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Kurumsal, güvenilir ve sürdürülebilir üretim anlayışı
                </li>
              </ul>
              <p style={{ marginTop: '30px', color: '#d0d0d0', fontSize: '17px', lineHeight: '1.9' }}>
                Gıda ile temas eden ürünlerden ağır sanayi taşımalarına kadar her alanda güvenle kullanılabilecek karton kutu ve ambalaj çözümleri ile işletmenizin tüm ihtiyaçlarını tek noktadan karşılıyoruz.
              </p>
              <p style={{ 
                marginTop: '25px', 
                fontWeight: '600', 
                color: '#d4af37',
                fontSize: '18px',
                fontStyle: 'italic',
                textAlign: 'center',
                padding: '20px',
                backgroundColor: 'rgba(212, 175, 55, 0.1)',
                borderRadius: '8px',
                border: '1px solid rgba(212, 175, 55, 0.3)'
              }}>
                Hangrup, ambalajda güven, kalite ve sürdürülebilir üretimin adresidir.
              </p>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* Güvenlik Sistemleri Modal */}
    {isGuvenlikModalOpen && (
      <div 
        className="modal-overlay" 
        onClick={closeGuvenlikModal}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}
      >
        <div 
          className="modal-content modal-content-responsive"
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: '#1a1a1a',
            borderRadius: '12px',
            maxWidth: '900px',
            width: '100%',
            maxHeight: '90vh',
            overflowY: 'auto',
            position: 'relative',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          <button
            onClick={closeGuvenlikModal}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'transparent',
              border: 'none',
              fontSize: '32px',
              cursor: 'pointer',
              color: '#fff',
              fontWeight: '300',
              lineHeight: '1',
              padding: '0',
              width: '35px',
              height: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
            }}
          >
            ×
          </button>
          <div style={{ marginBottom: '20px' }}>
            <h2 className="modal-heading-responsive" style={{ 
              fontWeight: '700', 
              marginBottom: '15px',
              color: '#fff',
              letterSpacing: '0.5px'
            }}>
              Güvenlik Sistemleri Çözümlerimiz – Hangrup
            </h2>
            <div className="modal-text-responsive" style={{ 
              lineHeight: '1.9', 
              color: '#e0e0e0',
              textAlign: 'justify'
            }}>
              <p style={{ marginBottom: '20px', color: '#d0d0d0' }}>
                Hangrup olarak, bireysel ve kurumsal tüm müşterilerimiz için yüksek teknolojiye sahip güvenlik sistemleri çözümleri sunuyoruz. İş yerleri, fabrikalar, depolar, konutlar, siteler ve ticari alanlar için uzaktan izlenebilir, güvenilir ve kesintisiz çalışan sistemler kuruyoruz.
              </p>
              <p style={{ marginBottom: '20px', color: '#d0d0d0' }}>
                Alanında uzman teknik ekibimiz, keşif aşamasından kurulum ve satış sonrası desteğe kadar tüm süreçleri profesyonel bir yaklaşımla yönetir. Güvenliğinizi en üst seviyeye taşıyan, ihtiyacınıza özel projelendirilmiş çözümler üretiriz.
              </p>
              <h3 className="modal-h3-responsive" style={{ 
                fontWeight: '600', 
                marginTop: '35px',
                marginBottom: '20px',
                color: '#fff',
                borderBottom: '2px solid #d4af37',
                paddingBottom: '10px'
              }}>
                Hizmetini Verdiğimiz Güvenlik Sistemleri
              </h3>
              <ul style={{ 
                marginBottom: '20px',
                paddingLeft: '25px',
                listStyleType: 'none',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '10px'
              }}>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Kamera Sistemleri (IP & Analog)
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Alarm Sistemleri
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Yangın Algılama Sistemleri
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Geçiş Kontrol Sistemleri
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Kartlı ve Biyometrik Geçiş Sistemleri
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Hırsız Alarm Sistemleri
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Plaka Tanıma Sistemleri
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Turnike ve Bariyer Sistemleri
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Network ve Zayıf Akım Sistemleri
                </li>
                <li style={{ marginBottom: '10px', color: '#e0e0e0', position: 'relative', paddingLeft: '20px' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37' }}>▸</span> Uzaktan İzleme ve Kayıt Sistemleri
                </li>
              </ul>
              <h3 className="modal-h3-responsive" style={{ 
                fontWeight: '600', 
                marginTop: '35px',
                marginBottom: '20px',
                color: '#fff',
                borderBottom: '2px solid #d4af37',
                paddingBottom: '10px'
              }}>
                Neden Hangrup Güvenlik Sistemleri?
              </h3>
              <ul style={{ 
                marginBottom: '20px',
                paddingLeft: '0',
                listStyleType: 'none'
              }}>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Keşif ve projelendirme hizmeti
                </li>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Yüksek çözünürlüklü ve kaliteli ekipmanlar
                </li>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Uzaktan erişim ve mobil izleme imkânı
                </li>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Hızlı kurulum ve teknik servis desteği
                </li>
                <li style={{ marginBottom: '12px', color: '#e0e0e0', paddingLeft: '30px', position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '0', color: '#d4af37', fontSize: '18px' }}>✓</span> Güvenilir, sürdürülebilir ve ekonomik çözümler
                </li>
              </ul>
              <p style={{ marginTop: '30px', color: '#d0d0d0', fontSize: '17px', lineHeight: '1.9' }}>
                Ticari işletmelerden konut projelerine kadar tüm alanlarda, 7/24 izlenebilir, güvenilir ve akıllı güvenlik çözümleri ile sevdiklerinizi ve yatırımlarınızı koruma altına alıyoruz.
              </p>
              <p style={{ 
                marginTop: '25px', 
                fontWeight: '600', 
                color: '#d4af37',
                fontSize: '18px',
                fontStyle: 'italic',
                textAlign: 'center',
                padding: '20px',
                backgroundColor: 'rgba(212, 175, 55, 0.1)',
                borderRadius: '8px',
                border: '1px solid rgba(212, 175, 55, 0.3)'
              }}>
                Hangrup Güvenlik Sistemleri, teknoloji, kalite ve güvenin birleştiği noktadır.
              </p>
            </div>
          </div>
        </div>
      </div>
    )}

  </div>
  );
};
